import { openkit } from "../../library/database";

export const getGoodsCategories = async () => {
  let resp = await openkit.custom.execute("post", "goods-categories", null, {});
  return resp;
};
